/** @format */

import React from "react";
import { CardType } from "../../resources/types";
import { ReactComponent as ExclamationCircle } from "bootstrap-icons/icons/exclamation-circle.svg";
import { Form } from "react-bootstrap";
import CardIcon from "../../activityCards/CardIcon";
import { useTranslation } from "react-i18next";
import { activityCardTypes, staticCardTypes } from "../utils";
import stringsCy from "../locales/strings.cy.json";
import stringsEn from "../locales/strings.en.json";

type Props = {
  type?: CardType;
  updateType: (value: CardType) => void;
  validated?: boolean;
};

const AddType: React.FC<Props> = ({ type, updateType, validated = false }) => {
  const { t: _ } = useTranslation();
  const { i18n } = useTranslation();
  i18n.addResources("cy", "translation", stringsCy);
  i18n.addResources("en", "translation", stringsEn);

  const onChangeType = ({
    target: { value },
  }: {
    target: { value: string };
  }) => {
    updateType(value as CardType);
  };

  return (
    <div className="position-relative">
      {validated && type === undefined && (
        <p className="text-danger">
          <ExclamationCircle
            style={{
              width: "20px",
              height: "20px",
              verticalAlign: "-0.25em",
            }}
          />
          {_("Please select a card type.")}
        </p>
      )}
      <p>
        <strong>{_("Static Cards")}</strong>
      </p>
      <Form.Group
        as="div"
        id="static-cards"
        className="card-type-select row-gap-3 column-gap-4 "
      >
        {staticCardTypes.map((_type: { name: string; id: string }) => (
          <Form.Check key={_type.id} className="h-100">
            <>
              <Form.Label
                htmlFor={`radio-type-${_type.id}`}
                className={`type-option h-100 type-${
                  _type.id
                } d-flex flex-column m-0 p-2 text-center justify-content-center align-items-center rounded ${
                  type === _type.id ? "selected" : ""
                }`}
              >
                <Form.Check.Input
                  id={`radio-type-${_type.id}`}
                  className="d-none"
                  name="cardtype"
                  type="radio"
                  value={_type.id}
                  checked={type === _type.id}
                  onChange={onChangeType}
                  required
                />
                <CardIcon activityType={_type.id} />
                <div className="flex-grow-1 d-flex align-items-center">
                  {_(_type.name)}
                </div>
              </Form.Label>
            </>
          </Form.Check>
        ))}
      </Form.Group>
      <br />
      <p>
        <strong>{_("Activity Cards")}</strong>
      </p>
      <div
        id="activity-cards"
        className="card-type-select row-gap-3 column-gap-4 "
      >
        {activityCardTypes.map((_type: { name: string; id: string }) => (
          <div key={_type.id} className="h-100">
            <Form.Check className="h-100">
              <Form.Label
                htmlFor={`radio-type-${_type.id}`}
                className={`type-option h-100 type-activity d-flex flex-column m-0 p-2 text-center justify-content-center align-items-center rounded ${
                  type === _type.id ? "selected" : ""
                }`}
              >
                <Form.Check.Input
                  id={`radio-type-${_type.id}`}
                  className="d-none"
                  name="cardtype"
                  type="radio"
                  value={_type.id}
                  checked={type === _type.id}
                  onChange={onChangeType}
                  required
                />
                <CardIcon activityType={_type.id} />
                <div className="flex-grow-1 d-flex align-items-center">
                  {_(_type.name)}
                </div>
              </Form.Label>
            </Form.Check>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddType;
